export const STATUS_COLORS = {
  default: '#e1e1e1',
  active: '#0b68fe',
  incorrect: '#F3163E',
  partiallyCorrect: '#FFA41B',
  mostlyCorrect: '#B2E5B2',
  correct: '#80D47F',
};
